'use strict';/* global define:false */define('modules/stats/states/stats/index',['require','text!./template.html','./controller'],function(require){'use strict';/**
   * Define the data restriction based on the roles
   *
   * @param {Function} roleCheck - Helper function to verify particular role.
   * @param {Object} ROLES - Definition of the possible roles.
   *
   * @returns {Object}
   */function restricted(roleCheck,ROLES){return roleCheck.promise(ROLES.supervisor,ROLES.admin,ROLES.wannabe);}restricted.$inject=['roleCheck','ROLES'];/**
   * Verify the provided roles
   *
   * @param {Function} roleCheck - Helper function to verify particular role.
   * @param {Object} ROLES - Definition of the possible roles.
   *
   * @returns {Boolean}
   */function menu(roleCheck,ROLES){return roleCheck(ROLES.supervisor,ROLES.admin,ROLES.wannabe);}menu.$inject=['roleCheck','ROLES'];return{url:'/stats',views:{'body@app':{template:require('text!./template.html'),controller:require('./controller'),controllerAs:'StatsCtrl'}},data:{restricted:restricted}};});
